const actions = {
	SET_DASHBOARD_HEADER: "SET_DASHBOARD_HEADER",
	SET_SELETED_TAB: "SET_SELETED_TAB",
	SET_MEMBER: "SET_MEMBER",
	SET_PROVIDER: "SET_PROVIDER"
};

export default actions;
